import React from 'react';
import {connect} from "react-redux";
import SubscriptionDialog  from "./SubscriptionDialog.jsx";

@connect ((store) =>{
	return {
		messages: store.messages.messages
	}
})

export default class ManageSubscription extends React.Component {
	constructor() {
		super();
	};

	render() {

		const { messages} = this.props;
		return (
			<div id="mangePage">
				<div className="col-md-12" >
					<div className="col-md-12">
						<p className="title stat-panel"> {messages["common.label.my.subscription"]}</p>
						<SubscriptionDialog />
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/opencell/pages/client/ManageSubscription.jsx